import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { add } from '../../action/history';

const AddToHistory = ({ listingId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(add(listingId));
  }, [listingId]);

  return null;
};
AddToHistory.defaultProps = {
  listingId: null,
};
AddToHistory.propTypes = {
  listingId: PropTypes.number,
};
AddToHistory.sanitizeProps = (props) => ({
  ...props,
  listingId: parseInt(props.listingId, 10),
});

export default AddToHistory;
